// extracted by mini-css-extract-plugin
export var contentBody = "_a4-9";
export var headerImage = "_a4-2";
export var imageButton = "_a4-7";
export var imageButtonIcon = "_a4-8";
export var imageHeader = "_a4-4";
export var imageHeaderText = "_a4-5";
export var imageOverlay = "_a4-3";
export var imageTitle = "_a4-6";
export var imageWrapper = "_a4-1";
export var taskList = "_a4-a";
export var widget = "_a4-0";